export function isMobile(): boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function isApple(): boolean {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}
